import { css } from '@emotion/core';
import { findLastIndex, unset } from 'lodash';
import { colorsPalette } from '../../../../../styles/colors';
import { MediaQueries } from '../../../../../styles/Grid';
import { typography, fontWeights } from '../../../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../../../utils/constants';

export const commonCss = css({
  marginTop: '36px',
  maxWidth: '416px',
  [MediaQueries.xl]: {
    maxWidth: '416px',
  },
  [MediaQueries.lg]: {
    maxWidth: '416px',
  },
  [MediaQueries.md]: {
    maxWidth: '320px',
  },
  h3: {
    fontSize: '28px',
    lineHeight: '40px',
    letterSpacing: '-0.4000000059604645px',
    textAlign: 'left',
    marginBottom: '16px',
    fontWeight: '500',
    [MediaQueries.sm]: {
      fontSize: '22px',
      lineHeight: '24px',
    },
    [MediaQueries.md]: {
      fontSize: '22px',
      lineHeight: '24px',
    },
  },
  form: {
    maxWidth: '500px',

    p: {
      fontSize: '14px',
      color: 'red',
      lineHeight: '16px',
    },

    '.tabbox': {
      [MediaQueries.md]: {
        paddingRight: '0px',
      },
    },
    '.ctasubmit': {
      marginTop: '16px',
      [MediaQueries.md]: {},
      [MediaQueries.xl]: {
        marginTop: '16px',
      },
      [MediaQueries.lg]: {
        marginTop: '16px',
      },
    },

    '.customdd': {
      [MediaQueries.sm]: {
        marginBottom: '16px',
      },
    },

    '.mb16': {
      [MediaQueries.lg]: {},
      [MediaQueries.md]: {},
      [MediaQueries.lg]: {},

      '.TypeAheadDropDown': {
        marginBottom: '0px',
      },
    },

    '.mb16:last-child': { marginBottom: '0px' },

    '.submit_btn': {
      background: '#E52500',
      width: '100%',
      height: '56px',
      color: '#fff',
      borderRadius: '8px',
      border: '0',
      fontSize: '14px',
      lineHeight: '18px',
      textTransform: 'uppercase',
      letterSpacing: '0.875px',
      textAlign: 'center',
      cursor: 'pointer',
    },

    '.submit_btn:hover': {
      background: '#d42705',
      outlineColor: '#d42705',
    },
  },
});

export const DarkModeCss = css({
  h3: {
    color: '#fff',
  },
});

export const LightModeCss = css({ color: '#393939' });
export const selectIconCss = css({
  font: 'normal normal normal 0.6rem/1 "regus-icon-font"',
  marginTop: '2px',
  [MediaQueries.md]: {
    font: 'normal normal normal 0.7rem/1 "regus-icon-font"',
    marginRight: '4px',
    fontSize: '10px',
  },
  [MediaQueries.sm]: {
    font: 'normal normal normal 0.7rem/1 "regus-icon-font"',
    marginRight: '4px',
    fontSize: '10px',
  },
});
